<template>
  <el-card>
    <el-form class="global-form2" ref="form" :model="formData" :rules="rules" label-width="120px" label-position="right">
      <el-form-item label="所属项目" prop="projectId">
        <el-select filterable v-model="formData.projectId" placeholder="请输入所属项目">
          <el-option :label="item.projectName" :value="item.projectId" v-for="(item, index) of projectList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出库仓库" prop="warehouseId">
        <el-select v-model="formData.warehouseId" placeholder="请选择" :disabled="!formData.projectId">
          <el-option :label="item.warehouseName" :value="item.warehouseId" v-for="(item, index) of warehouseData" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出库日期" prop="checkoutDate">
        <el-date-picker v-model="formData.checkoutDate" value-format="yyyy-MM-dd" type="date" placeholder="请选择出库日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="领用人" prop="checkoutUser">
        <el-select v-model="formData.checkoutUser" filterable placeholder="请选择领用人" :disabled="!formData.projectId">
          <el-option
            v-for="item in projectUserList"
            :key="item.userId"
            :label="item.userName"
            :value="item.userId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出库说明" prop="checkoutExplain">
        <div class="textarea-remark">
          <el-input type="textarea" maxlength="300" :autosize="{ minRows: 4, maxRows: 8}" v-model="formData.checkoutExplain" placeholder="请输入出库说明"></el-input>
          <span>{{formData.checkoutExplain.length}}/300</span>
        </div>
      </el-form-item>
      <el-form-item label="出库物料明细" prop="detailedList">
      </el-form-item>
      <el-table class="global-table material-table" :data="formData.detailedList">
        <el-table-column prop="materialTypeName" label="物料分类" show-overflow-tooltip></el-table-column>
        <el-table-column prop="materialName" label="物料名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="specifications" label="规格型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="brand" label="品牌名称" show-overflow-tooltip></el-table-column>
        <el-table-column label="单价" prop="unitPrice"></el-table-column>
        <el-table-column label="单位" prop="company"></el-table-column>
        <el-table-column prop="stock" label="剩余库存" show-overflow-tooltip></el-table-column>
        <el-table-column  prop="checkoutType">
          <template slot="header">
              <span style="color: #f00;font-size: 14px;margin-right: 4px;">*</span>出库类型
          </template>
          <template v-slot="{ row, $index }">
            <el-form-item label-width="'0'" :prop="'detailedList.' + $index + '.checkoutType'"
              :rules='rules.checkoutType'>
              <el-select v-model="row.checkoutType" placeholder="请选择">
                <el-option v-for="item in checkoutTypeData" :key="item.dicId" :label="item.dicValue"
                  :value="item.dicValue"></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column  prop="operationStock">
          <template slot="header">
              <span style="color: #f00;font-size: 14px;margin-right: 4px;">*</span>出库数量
          </template>
          <template v-slot="{ row, $index }">
            <el-form-item label-width="'0'" :prop="'detailedList.' + $index + '.operationStock'"
              :rules='rules.operationStock'>
              <el-input maxlength="30" v-model="row.operationStock" placeholder="请输入"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="用途说明" prop="bak">
          <template v-slot="{ row }">
            <el-input v-model.number="row.bak" placeholder="请输入" maxlength="50"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="">
          <template v-slot="{ $index }">
            <el-button class="del-btn" type="text" @click="deleteDetailedList($index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="text" class="mt10" icon="el-icon-plus" @click="loadmaterialList">新增出库物料</el-button>
      <el-form-item label="出库图片" prop="imgList" class="mt30">
        <div class="imgList">
          <div class="imgBlock" v-for="(item, index) in formData.imgList" :key="index">
            <el-image
              :src="item.filePrefix + item.fileUrl"
              :preview-src-list="[item.filePrefix + item.fileUrl]"
              fit="fill">
            </el-image>
            <span></span>
            <i class="el-icon-close" @click="imgRemove(index)"></i>
          </div>
          <UploadFile :accept="'jpeg,jpg,png'"  @onSuccess= "onSuccess" :slotShow='true' v-if="formData.imgList.length < 6">
            <i class="el-icon-plus"></i>
            <p>上传图片</p>
          </UploadFile>
        </div>
        <div class="mt20">(最多六张)</div>
      </el-form-item>
      <el-form-item label="上传文件" prop="fileList">
        <UploadFile listType="text" @onSuccess="onSuccess2" :slotShow='true' accept="TXT、DOC、XLS、PPT、DOCX、XLSX、PPTX、JPG、PNG、PDF、TIFF、SWF">
          <template>
            <div class="file">
              <template>
                <el-link icon="el-icon-upload" type='primary' :underline="false">{{formData.fileList.length === 0 ? "点击上传" : '重新上传'}}</el-link>
                <el-tooltip class="item" effect="dark" content="支持文件格式：TXT、DOC、XLS、PPT、DOCX、XLSX、PPTX、JPG、PNG、PDF、TIFF、SWF，文件大小不超过10M；" placement="right">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
            </div>
          </template>
        </UploadFile>
        <el-form-item v-if="formData.fileList.length!==0">
          {{formData.fileList[0].fileName}}
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="物料清单" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
      <el-form class="global-form" inline label-width="100px">
        <el-form-item prop="materialName">
          <el-input v-model="searchForm.materialName" clearable placeholder="请输入产品名称"></el-input>
        </el-form-item>
      <el-form-item prop="materialTypeId">
        <el-cascader v-model="searchForm.materialTypeId" :options="materialTypeData" :props="{ checkStrictly: true, emitPath: false, children: 'childNode', label: 'materialTypeName', value: 'materialTypeId' }" placeholder="请选择物料分类" clearable></el-cascader>
      </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.supplierId" clearable placeholder="供应商名称">
            <el-option
                v-for="item in supplierData"
                :key="item.supplierId"
                :label="item.supplierName"
                :value="item.supplierId"
              ></el-option>
            </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearchWorkOrder">查询</el-button>
        </el-form-item>
      </el-form>
        <el-table ref="table" @selection-change="selectionLineChangeHandle" class="global-table" reserve-selection = true :row-key="getRowKeys"  :data="tableData">
          <el-table-column reserve-selection type="selection" :selectable="selectable"></el-table-column>
          <el-table-column prop="materialName" label="物料名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="specifications" label="规格型号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="brand" label="品牌名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="materialTypeName" label="物料分类" show-overflow-tooltip></el-table-column>
          <el-table-column prop="supplierName" label="供应商名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="latestStorageTime" label="入库日期" min-width="90" show-overflow-tooltip></el-table-column>
          <el-table-column prop="stock" label="剩余库存" show-overflow-tooltip></el-table-column>
        </el-table>

      <global-pagination
        @size-change="getMaterialData"
        @current-change="getMaterialData"
        :current-page.sync="page"
        :page-size.sync="size"
        :total="total">
      </global-pagination>
      <el-button type="primary" @click="confirm">确定</el-button>
      <el-button @click="dialogVisible = false">取消</el-button>
    </el-dialog>
  </el-card>
</template>

<script>
import UploadFile from '@/components/uploadFile/Index.vue'

const operationStockV = (rule, value, callback) => {
  const reg = /^[1-9][0-9]*$/
  if (!reg.test(value) || Number(value) > 9999999) {
    return callback(new Error('请输入1到9999999整数'))
  } else {
    return callback()
  }
}
export default {
  name: 'ExwarehouseAdd',
  components: {
    UploadFile
  },
  data () {
    return {
      formData: {
        projectId: '',
        warehouseId: '',
        checkoutDate: '',
        checkoutUser: '',
        checkoutExplain: '',
        imgList: [],
        fileList: [],
        detailedList: []
      },
      tableData: [],
      loading: false,
      searchForm: {
        materialName: '',
        supplierId: '',
        materialTypeId: '',
        stock: '1'
      },
      dialogVisible: false,
      page: 1,
      total: 0,
      size: 10,
      selectItems: [], // 选中的临时物料
      warehouseData: [], // 仓库
      projectUserList: [],
      supplierData: [], // 供应商类型
      materialTypeData: [],
      checkoutTypeData: [],//出库类型
      rules: {
        projectId: [
          { required: true, message: '请选择所属项目', trigger: 'blur' }
        ],
        warehouseId: [
          { required: true, message: '请选择出库仓库', trigger: 'blur' }
        ],
        checkoutDate: [
          { required: true, message: '请选择出库日期', trigger: 'blur' }
        ],
        checkoutUser: [
          { required: true, message: '请选择领用人', trigger: 'blur' }
        ],
        detailedList: [
          { required: true, type: 'array', message: '请添加出库物料明细', trigger: 'blur' }
        ],
        checkoutType: [
          { required: true, message: '请选择出库类型', trigger: 'change' }
        ],
        operationStock: [
          { required: true, message: '请输入出库数量', trigger: 'change' },
          { validator: operationStockV, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList
    }
  },
  watch: {
    'formData.projectId' () {
      // 重置领用人
      this.$axios.get(this.$apis.project.selectYhProjectUserByList, {
        projectId: this.formData.projectId
      }).then(res => {
        this.projectUserList = res || []
        this.formData.checkoutUser = ''
      })

      // 重置仓库及出库物料
      this.$axios.get(this.$apis.material.selectYhWarehouseByList, {
        projectId: this.formData.projectId
      }).then(res => {
        this.warehouseData = res.list
        this.formData.warehouseId = ''
      })
      this.formData.detailedList = []
    }
  },
  created () {
    this.loadCheckoutType()
    this.loadMaterialType()
    this.loadSupplierType() // 加载供应商
  },
  methods: {
    getRowKeys (row) {
      return row.materialId
    },
    loadCheckoutType() {
      this.$axios.get(this.$apis.common.selectDicByList, {
        dicType: 'checkoutType'
      }).then((res) => {
        this.checkoutTypeData = res.checkoutType || []
      })
    },
    loadMaterialType () {
      this.$axios.get(this.$apis.material.selectYhMaterialTypeByList).then(res => {
        this.materialTypeData = res || []
      })
    },
    // 加载供应商
    loadSupplierType () {
      this.$axios.get(this.$apis.material.selectYhSupplierByPage).then(res => {
        this.supplierData = res.list
      })
    },
    deleteDetailedList (index) {
      this.formData.detailedList.splice(index, 1)
    },
    loadmaterialList () {
      if (!this.formData.warehouseId) {
        this.$message({ type: 'warning', message: '请选择出库仓库' })
      } else {
        this.page = 1
        this.dialogVisible = true
        this.getMaterialData()
        this.$nextTick(() => {
          this.$refs.table.clearSelection()
          this.formData.detailedList.forEach(item => {
            this.$refs.table.toggleRowSelection(item, true)
          })
        })
      }
    },
    getMaterialData () {
      // this.tableData.loading = true
      this.$axios.get(this.$apis.material.selectYhMaterialByPage, {
        ...this.searchForm,
        page: this.page,
        size: this.size,
        warehouseId: this.formData.warehouseId
      }).then(res => {
        // console.log('res', res)
        this.total = res.total || 0
        this.tableData = res.list || []
      })
    },
    selectionLineChangeHandle (val) {
      // console.log('val', val)
      this.selectItems = val
    },
    // 选择工单
    confirm () {
      let arr = []
      arr = this.selectItems.filter((item) => {
        return this.formData.detailedList.every((k) => {
          return item.materialId !== k.materialId
        })
      })
      this.formData.detailedList = [...this.formData.detailedList, ...arr]
      this.dialogVisible = false
    },
    onSearchWorkOrder () {
      this.page = 1
      this.getMaterialData()
    },
    // 图片成功返回
    onSuccess (file) {
      this.formData.imgList.push(file)
    },
    imgRemove (index) {
      this.formData.imgList.splice(index, 1)
    },
    // 文件上传
    onSuccess2 (file) {
      this.formData.fileList = [file]
    },
    submit () {
      const form = JSON.parse(JSON.stringify(this.formData))
      // console.log('form', form)
      this.$refs.form.validate(valid => {
        if (valid) {
          for (let i = 0; i < form.detailedList.length; i++) {
            const item = {
              materialId: form.detailedList[i].materialId,
              operationStock: form.detailedList[i].operationStock,
              bak: form.detailedList[i].bak,
              stock: form.detailedList[i].stock,
              checkoutType: form.detailedList[i].checkoutType
            }
            if (!item.operationStock || ((!Number(item.operationStock) || item.operationStock <= 0) || item.operationStock > item.stock)) {
              this.$message({ type: 'warning', message: '出库数量为正整数且小于剩余库存数量' })
              return
            }
            delete item.stock
            form.detailedList[i] = item
          }
          this.$axios.post(this.$apis.material.insertYhCheckout, form).then(() => {
            this.$router.back()
          })
        }
      })
    },
    selectable (row) {
      return !this.formData.detailedList.some((item) => item.materialId === row.materialId)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/scss/color";
.global-form2 {
  ::v-deep .material-table {
    .el-input,
    .el-select,
    .el-cascader {
      width: 100% !important;
    }

    .el-form-item {
      margin-bottom: 0
    }

    ;

    .el-form-item--small.el-form-item {
      margin-bottom: 0
    }

    .cell {
      height: 62px;
      display: flex;
      align-items: center
    }
  }
}

.el-textarea {
  width: 380px;
}

.textarea-remark {
  width: 380px;
  position: relative;

  span {
    position: absolute;
    right: 10px;
    bottom: 0px;
    font-size: 12px;
    color: #bbb;
  }
}
.imgList{
    width: 100%;
    min-height: 104px;
    display: flex;
    margin-top: 15px;
    flex-wrap: wrap;
    .imgListTitle{
      margin-right: 10px;
    }
    .imgBlock {
      position: relative;
      height: 104px;
      width: 104px;
      margin:0 10px 10px 0 !important;
      .el-image,img,video{
        width:100%;
        height: 100%;
      }
      span {
        position: absolute;
        top: 0;
        right: 0;
        width: 0px;
        height: 0px;
        border-top: 34px solid $color-default;
        border-left: 34px solid transparent;
      }

      i {
        transition: all 0.3s;
        position: absolute;
        top: 3px;
        right: 3px;
        font-size: 15px;
        color: #ffffff;
        cursor: pointer;
      }
      i:hover {
        color: #ffffff98;
      }
    }
    ::v-deep .el-upload--picture-card{
      width: 104px;
      height: 104px;
      line-height: 26px;
      padding:25px 10px;
      i{
        font-size: 22px;
        color: #999;
        margin-bottom: 7px;
      }
    }
    ::v-deep .el-upload{
      display: flex;
      flex-direction: column;
      justify-content: center !important;
      align-items: center !important;
    }
  }
</style>
